export default "__VITE_ASSET__DOFJS8Fq__"